import { render, staticRenderFns } from "./sendSuccessfully.vue?vue&type=template&id=63da8f26&scoped=true&"
import script from "./sendSuccessfully.vue?vue&type=script&lang=js&"
export * from "./sendSuccessfully.vue?vue&type=script&lang=js&"
import style0 from "./sendSuccessfully.vue?vue&type=style&index=0&id=63da8f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da8f26",
  null
  
)

export default component.exports